import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './Common/LoadingSpinner';

const AuthGate = ({ children }) => {
    const { loading } = useAuth();

    if (loading) {
        return <LoadingSpinner text="Restoring session..." />;
    }

    return children;
};

export default AuthGate;
